import React, { useEffect, useState } from "react";
import { HandHeart, Quote } from "lucide-react";
import api from "@/lib/api";

// "Most-loved" event comments across the community, ranked by Amens.
export default function TopComments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events/comments/top", { params: { limit: 5 } }).then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section className="mb-10" data-testid="amen-leaderboard">
      <div className="flex items-center gap-2 mb-4">
        <HandHeart className="w-5 h-5 text-[#E6B34A]" />
        <h2 className="font-display font-extrabold text-lg lg:text-2xl tracking-tight">Most-Loved Words</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map((c, i) => (
          <div key={c.id} data-testid={`top-comment-${c.id}`} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 relative">
            <Quote className="w-6 h-6 text-[#E6B34A]/30 absolute top-4 right-4" />
            {i === 0 && <span className="inline-block text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#E6B34A] text-[#0A1030] mb-2">★ Top</span>}
            <p className="text-sm text-zinc-200 leading-relaxed">“{c.text}”</p>
            <div className="flex items-center justify-between mt-4 text-xs">
              <span className="text-zinc-400 truncate">— {c.user_name || "A member"} · <span className="text-zinc-500">{c.event_title}</span></span>
              <span className="inline-flex items-center gap-1 text-[#E6B34A] font-semibold shrink-0"><HandHeart className="w-3.5 h-3.5" /> {c.amen_count}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
